var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractorViolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_662",
    "data-name": "Group 662",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.782,
    y1: 0.902,
    x2: 0.191,
    y2: 0.11,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e00d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb009d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#fe8045"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_36",
    "data-name": "Mask Group 36",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "euvSG3",
    transform: "translate(10.936 7.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M-3245.969,2199.863a28.861,28.861,0,0,1-10.769-1.817,22.125,22.125,0,0,1-2.948-1.567,1.67,1.67,0,0,1-.769-1.784,8.931,8.931,0,0,1,3.649-5.994,18.312,18.312,0,0,1,6.97-3.256.656.656,0,0,1,.483.117c1.063.8,2.124,1.611,3.158,2.449a.508.508,0,0,0,.776-.017c1.026-.825,2.073-1.624,3.125-2.418a.653.653,0,0,1,.479-.131,17.623,17.623,0,0,1,7.729,3.927,8.7,8.7,0,0,1,2.869,5.248,1.85,1.85,0,0,1-.825,1.95,18.281,18.281,0,0,1-6.519,2.589A35.849,35.849,0,0,1-3245.969,2199.863Zm.154-2.255c.6-.946,1.164-1.817,1.705-2.7a.581.581,0,0,0-.014-.391c-.335-1.239-.679-2.475-1.021-3.713-.2-.742-.407-1.484-.647-2.359-.074.183-.1.23-.112.281-.514,1.966-1.029,3.931-1.53,5.9a.626.626,0,0,0,.066.427C-3246.877,2195.881-3246.369,2196.7-3245.814,2197.608Zm8.776-4.93h-4.158v1.044h4.158Z",
    transform: "translate(3260.478 -2157.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M-3176.849,1959.842c.4-1.712.791-3.361,1.18-5.01.158-.669.341-1.333.463-2.009.038-.207-.02-.564-.152-.637a.879.879,0,0,0-.708.048,12.574,12.574,0,0,0-1.2.789,12.065,12.065,0,0,0-.548-1.212c-.113-.195-.354-.437-.534-.435s-.426.241-.541.436a13.1,13.1,0,0,0-.587,1.256c-.445-.279-.852-.576-1.3-.8a.877.877,0,0,0-.7-.035c-.126.068-.184.423-.14.621.491,2.238,1.009,4.47,1.519,6.7.017.073.024.148.044.28-.614,0-1.207.015-1.8-.013a.466.466,0,0,1-.311-.279,13.138,13.138,0,0,1-.444-1.484,4.905,4.905,0,0,0-1.011-2.13,10.645,10.645,0,0,1-2.579-6.018,7.362,7.362,0,0,1,5.089-7.568,8.039,8.039,0,0,1,9.48,3.161,7.463,7.463,0,0,1,.56,6.415,11.324,11.324,0,0,1-2.349,4.168,4.857,4.857,0,0,0-.937,2.311c-.031.149-.054.3-.094.448-.244.891-.371.988-1.282.988Z",
    transform: "translate(3193.056 -1936.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M-3123.381,2065.1c1.34.688,1.34.688,2-.463.25.324.451.833.783.941.312.1.76-.221,1.206-.377-.465,2.007-.936,4.037-1.407,6.07h-1.146Z",
    transform: "translate(3136.015 -2047.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M-3137.233,2161.57h6.613a2.617,2.617,0,0,1-2.061,1.555.858.858,0,0,0-.659.393.753.753,0,0,1-1.217-.017,1.148,1.148,0,0,0-.566-.351A2.766,2.766,0,0,1-3137.233,2161.57Z",
    transform: "translate(3148.59 -2135.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M-3131.945,2144.166v.923h-6.879v-.923Z",
    transform: "translate(3150.034 -2119.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M-3257.137,2022.949c-.488,0-.977,0-1.465,0-.3,0-.561-.092-.558-.454s.264-.441.568-.441q1.443,0,2.885,0c.307,0,.577.089.587.432.01.374-.271.468-.6.466-.473,0-.946,0-1.419,0Z",
    transform: "translate(3259.281 -2009.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M-3235.3,2077.786a1.368,1.368,0,0,1-.316.313c-.859.468-1.729.917-2.595,1.371-.263.139-.511.151-.667-.144s.021-.492.274-.625c.865-.457,1.729-.915,2.6-1.362A.465.465,0,0,1-3235.3,2077.786Z",
    transform: "translate(3240.923 -2059.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M-3004.73,2076.434c.175.066.279.093.371.141q1.256.657,2.509,1.321c.262.14.551.3.349.665-.187.339-.471.253-.752.1-.848-.451-1.7-.886-2.542-1.358a.587.587,0,0,1-.26-.456C-3005.04,2076.7-3004.841,2076.567-3004.73,2076.434Z",
    transform: "translate(3028.593 -2058.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M-3238.135,1951.333c.175.078.26.111.341.153q1.236.646,2.472,1.3c.264.14.55.3.347.663-.185.333-.451.267-.743.108-.845-.458-1.708-.884-2.544-1.357a.6.6,0,0,1-.251-.495C-3238.489,1951.554-3238.255,1951.441-3238.135,1951.333Z",
    transform: "translate(3240.541 -1944.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M-3004.481,1955.109c-.087-.083-.313-.2-.308-.315a.752.752,0,0,1,.263-.546c.6-.361,1.232-.666,1.852-.991a4.793,4.793,0,0,1,.857-.424.579.579,0,0,1,.525.164.553.553,0,0,1-.108.536c-.939.533-1.9,1.024-2.86,1.526A1.3,1.3,0,0,1-3004.481,1955.109Z",
    transform: "translate(3028.35 -1946.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M-3105.305,1883.781c0,.429,0,.857,0,1.286,0,.312-.108.575-.446.58s-.453-.243-.451-.565c.006-.888,0-1.776,0-2.664,0-.3.121-.576.422-.524a.733.733,0,0,1,.449.513,9.345,9.345,0,0,1,.021,1.375Z",
    transform: "translate(3120.418 -1881.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M-2987.25,2023.619c-.519,0-1.039,0-1.558,0-.281,0-.537-.112-.483-.4a.663.663,0,0,1,.467-.429c1.037-.039,2.077-.035,3.115,0,.153.005.3.255.445.392-.142.144-.273.4-.429.411a15.336,15.336,0,0,1-1.556.02Z",
    transform: "translate(3014.289 -2009.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M-3045.871,1901.853c-.076.152-.123.265-.187.367-.487.778-.984,1.55-1.462,2.334-.164.269-.371.385-.641.218a.418.418,0,0,1-.1-.642c.507-.8,1-1.613,1.533-2.4a.7.7,0,0,1,.532-.214C-3046.085,1901.52-3045.979,1901.734-3045.871,1901.853Z",
    transform: "translate(3067.911 -1899.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M-3179.667,1904.1c-.088.1-.19.318-.3.32a.712.712,0,0,1-.533-.213c-.427-.612-.808-1.257-1.205-1.89a2.218,2.218,0,0,1-.348-.586.626.626,0,0,1,.123-.546.554.554,0,0,1,.542.1c.572.846,1.1,1.72,1.643,2.587A1.221,1.221,0,0,1-3179.667,1904.1Z",
    transform: "translate(3189.289 -1899.376)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractorViolet);
export default __webpack_public_path__ + "static/media/contractorViolet.555e14786c8b7486537c2c390fdbb5f1.svg";
export { ForwardRef as ReactComponent };